import DOMPurify from 'isomorphic-dompurify'

export function isExternalHref(href: string): boolean {
  if (!href) return false
  const trimmed = href.trim()
  if (
    trimmed.startsWith('#') ||
    trimmed.startsWith('/') ||
    trimmed.startsWith('mailto:') ||
    trimmed.startsWith('tel:') ||
    trimmed.startsWith('sms:')
  ) {
    return false
  }
  try {
    const url = new URL(trimmed, 'https://culineerapp.com')
    if (url.protocol !== 'http:' && url.protocol !== 'https:') return false
    const host = url.hostname.replace(/^www\./, '')
    if (host === 'culineerapp.com' || host === 'localhost' || host.endsWith('.culineerapp.com')) {
      return false
    }
    return true
  } catch {
    return /^https?:\/\//i.test(trimmed)
  }
}

export function externalLinkAttrs(href: string): {
  href: string
  target?: string
  rel?: string
} {
  if (isExternalHref(href)) {
    return { href, target: '_blank', rel: 'noopener noreferrer' }
  }
  return { href }
}

let hooked = false
function ensureExternalLinkHook() {
  if (hooked) return
  hooked = true
  DOMPurify.addHook('afterSanitizeAttributes', (node) => {
    if (node.tagName === 'A' && node.hasAttribute('href')) {
      const href = node.getAttribute('href') || ''
      if (isExternalHref(href)) {
        node.setAttribute('target', '_blank')
        node.setAttribute('rel', 'noopener noreferrer')
      }
    }
  })
}

export function sanitizeHtml(html: string, config?: Parameters<typeof DOMPurify.sanitize>[1]) {
  ensureExternalLinkHook()
  return DOMPurify.sanitize(html ?? '', {
    ADD_ATTR: ['target', 'rel'],
    ...config,
  })
}

/** Opens off-site links in a new tab even if the stored HTML omitted target=_blank. */
export function handleExternalContentClick(event: { target: EventTarget | null; preventDefault: () => void }) {
  const el = event.target as HTMLElement | null
  const anchor = el?.closest?.('a')
  if (!anchor) return
  const href = anchor.getAttribute('href') || ''
  if (!isExternalHref(href) && !isExternalHref(anchor.href)) return
  event.preventDefault()
  window.open(anchor.href, '_blank', 'noopener,noreferrer')
}
